import { forwardRef } from 'react'

import { Button, ButtonTypes, LinkTypes, SimplifiedIcons } from '@cox/core-ui8/dist/Button'

import { AddressCaptureInputProps } from './types'
import ReactButton, { ReactButtonProps } from '../../../ReactButton'

import './AddressCaptureInput.scss'

const AddressCaptureInput = forwardRef((props: AddressCaptureInputProps, ref: any): JSX.Element => {
  const {
    theme,
    locationPin,
    simplifiedIcon,
    value,
    unit,
    zipcode,
    searchProgress,
    searchCompleted,
    displayInputs,
    streetInputPlaceholder,
    isBusiness,
    updateValue,
    setUnit,
    setUnitNumber,
    setHouseNumber,
    setZipcode,
    setSuggestionsActive,
    handleKeyDown,
    onEdit,
    onSubmit
  } = props

  const checkAvilabilitynProps: ReactButtonProps = {
    buttonTypes: ButtonTypes.PRIMARY,
    id: 'test-primary-button',
    isInEditor: false,
    linkType: LinkTypes.PAGE,
    linkUrl: '',
    text: 'Check availability',
    simplified: SimplifiedIcons.CHEVRON
  }

  return (
    <div className={'react-ac-search-container ' + theme}>
      <div className='react-address-search-input'>
        <div className='search-icon'>
          <img src={locationPin} className='cox-icon' alt={'location icon'} />
        </div>

        {!searchProgress && (
          <input
            type='text'
            placeholder={streetInputPlaceholder}
            className={!displayInputs ? 'full-width' : ''}
            ref={ref}
            value={value}
            onChange={(event) => updateValue(event)}
            onKeyDown={handleKeyDown}
            onBlur={() => setSuggestionsActive(false)}
            onMouseUp={() => setSuggestionsActive(true)}
            onTouchEnd={() => setSuggestionsActive(true)}
          />
        )}

        {searchProgress && (
          <div className='react-address-single-field px-2'>{value + (unit && ', ' + unit) + ', ' + zipcode}</div>
        )}
      </div>

      <div className='react-search-input-button'>
        {!searchProgress && !searchCompleted && displayInputs && (
          <>
            <input
              className='additional-input'
              type='text'
              value={unit}
              placeholder='Unit #'
              onChange={(e) => {
                setUnit(e.target.value.trim())
                if (isBusiness) {
                  setUnitNumber(e.target.value.trim())
                  setHouseNumber('')
                }
              }}
            />
            <input
              className='additional-input'
              type='text'
              value={zipcode}
              placeholder='Zip Code'
              onChange={(e) => setZipcode(e.target.value?.trim())}
            />
          </>
        )}

        {!searchProgress && !searchCompleted && (
          <ReactButton {...checkAvilabilitynProps} activeIcon={simplifiedIcon} customClickEvent={onSubmit}></ReactButton>
        )}

        {searchProgress && !searchCompleted && (
          <div className='search-spinner-container'>
            <div className='search-spinner-loader'></div>
          </div>
        )}

        {searchProgress && searchCompleted && (
          <Button
            className='react-ac-edit-address'
            buttonTypes={ButtonTypes.TERTIARY}
            id='test-primary-button'
            text='Edit address'
            customClickEvent={onEdit}
          ></Button>
        )}
      </div>
    </div>
  )
})

export default AddressCaptureInput
